import { useCallback, useMemo } from 'react'
import { useRouteMatch } from 'react-router-dom'

import HomeDevicesRoutes from './DevicesRoutes'
import { DEVICES_ROUTES } from './routes'

function HomeDevices() {
  const { path, url } = useRouteMatch()

  const buildHomeRoutePath = useCallback(
    (routePath: string) => `${path}/${routePath}`,
    [path]
  )

  const buildHomeMenuLinkPath = useCallback(
    (path: string) => `${url}/${path}`,
    [url]
  )

  const routes = useMemo(
    () =>
      DEVICES_ROUTES.map(({ path, component }) => ({
        path: buildHomeRoutePath(path),
        component,
      })),
    [buildHomeRoutePath]
  )

  const defaultRoute = buildHomeMenuLinkPath(DEVICES_ROUTES[0].path)

  return (
    <HomeDevicesRoutes defaultRoute={defaultRoute} devicesRoutes={routes} />
  )
}

export default HomeDevices
